const initialState = [];
//
export default function cmSdepth0004(state = initialState, action) {
  switch (action.type) {
    case 'SET_CMSDEPTH0004':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CMSDEPTH0004_ERROR':
      return state;
    default:
      return state;
  }
}
